import axios from "axios";

const customer = axios.create({
  // baseURL: "http://202.131.123.110:1337",
  // baseURL: "http://localhost:1337",
  // baseURL: "http://202.131.123.110:1337",
  baseURL: "https://vibo-api.herokuapp.com",
  headers: {
    "Content-Type": "application/json",
  },
});

export default customer;



// WEBPACK FOOTER //
// ./services/customer.js